<div
  [style.border]="itemStyle().card.border"
  [style.boxShadow]="itemStyle().card.boxShadow"
  [style.background]="itemStyle().card.background"
  [style.borderRadius]="itemStyle().card.borderRadius"
  class="card {{ dataService.environment().retailerName }} {{
    dataService.currentPage()
  }}"
>
  @let picture = stepContent().picture;
  @if (picture) {
    <img
      class="step-img"
      [src]="picture.imageUrl"
      [alt]="picture.alternativeText | replaceVars: maxSelectedChallenges"
    />
  }
  <div class="card-body">
    <p
      class="card-title"
      [style.color]="itemStyle().title.color"
      [style.fontFamily]="itemStyle().title.fontFamily"
    >
      {{ stepContent().title }}
    </p>
    <p
      class="card-text"
      [style.color]="itemStyle().description.color"
      [style.fontFamily]="itemStyle().description.fontFamily"
      [innerHTML]="
        stepContent().description | replaceVars: maxSelectedChallenges | safe
      "
    ></p>
  </div>
</div>
